
import * as React from "react";
import {FormsRow} from "./FormsRow";

export class FormGroup extends React.Component<FormGroupProps, FormGroupState> {
    static defaultProps: Partial<FormGroupProps> = {};

    constructor(props: FormGroupProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <React.Fragment>
                <thead>
                    <tr>
                        {formsVar.Design.Columns.map(x=>
                            <th style={{fontSize:12,width:x.Width+'%'}}>{this.FormatLabel(x.Label)}</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {this.props.FormGroup.Rows.map(row=>
                        <FormsRow Data={row}/>
                    )}
                </tbody>
            </React.Fragment>
        )
    }

    private FormatLabel(Label: string) {
        if(Label=='$Name$')
            return this.props.FormGroup.GroupName;
        return Label;
    }
}



//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormGroupProps {
    FormGroup:FormDataGroup;
}

interface FormGroupState {

}

//#endregion "My Region"